var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.85,
    height: 17.25,
    viewBox: "0 0 23.85 17.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-laptop-1075240",
    transform: "translate(-134.892 -124.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_709",
    "data-name": "Trac\\xE9 709",
    d: "M171.995,138.866H190.85a.542.542,0,0,0,.542-.542V124.957a.542.542,0,0,0-.542-.542H171.995a.542.542,0,0,0-.542.542v13.365a.542.542,0,0,0,.542.543Zm.542-13.366h17.77v12.282h-17.77Z",
    transform: "translate(-34.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_710",
    "data-name": "Trac\\xE9 710",
    d: "M158.094,412.25H135.539a.647.647,0,1,0,0,1.294h22.556a.647.647,0,1,0,0-1.294Z",
    transform: "translate(0 -271.878)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.ba746cde7ff83dc5dee2955b61e0781c.svg";
export { ForwardRef as ReactComponent };